/**
 * Display helpers for table identifiers.
 *
 * Admins can give individual tables a custom label (e.g. "Window Table",
 * "VIP") on an event. Labels are pure display decoration layered on top of
 * the immutable integer `table_number` — players are linked to a table
 * ONLY by that integer, so renaming a table never detaches its assignments.
 *
 * This is the single source of truth for "what should the UI render
 * instead of 'Table N'?". Use it everywhere a table is named, so adding /
 * removing a label is consistent across admin / host / public views.
 */

/**
 * Returns the display name for a table, falling back to `Table {n}` when
 * no custom label is set or the label is empty/whitespace.
 *
 * @param {object|null|undefined} event  The event object (may be null while loading).
 * @param {number|string|null|undefined} tableNumber  The integer table number.
 * @returns {string}
 */
export function tableDisplayName(event, tableNumber) {
  if (tableNumber === null || tableNumber === undefined || tableNumber === "") {
    return "";
  }
  const labels = event?.table_labels;
  if (labels && typeof labels === "object") {
    const label = labels[String(tableNumber)];
    if (typeof label === "string") {
      const trimmed = label.trim();
      if (trimmed.length > 0) return trimmed;
    }
  }
  return `Table ${tableNumber}`;
}
